import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { LoadingService } from '../../../services/loading.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { NgIf } from '@angular/common';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { Offcanvas } from 'bootstrap';
import { HttpServiceService } from '../../../services/http-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxToastrService } from '../../../_services/ngx-toastr/ngx-toastr.service';
import { Subscription } from 'rxjs';
import { USER_PERMISSIONS } from '../../../app.constants';
import { LocalStorageService } from '../../../services/local-storage.service';

@Component({
  selector: 'app-owner-local-contact-person',
  imports: [OwnerOverviewComponent,ReactiveFormsModule, NgIf, BreadcrumbComponent],
  templateUrl: './owner-local-contact-person.component.html',
  styleUrl: './owner-local-contact-person.component.css'
})
export class OwnerLocalContactPersonComponent {
  breadcrumbList : any;
  local_person_details : boolean = false;
  loadingService = inject(LoadingService);
  localPersonForm: FormGroup;
  ownerLocalContactDetails : any;
  userId : string = '';
  @ViewChild('addEditLocalContactButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  private updateOwnerBankdetailSubscription? : Subscription;
  private routeSubscription?: Subscription;
  addProperty? : string;
  private authService = inject(LocalStorageService);

  constructor(private fb: FormBuilder, private httpService : HttpServiceService, private route: ActivatedRoute, private alertService: NgxToastrService, private router: Router){
    this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = { 
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Local Contact',
        breadcrumb_url : '/admin/'+ (userType == "owner" ? "owners" : "tenants") 
      }
    });
    this.localPersonForm = this.fb.group({
      local_first_name: ['', [Validators.required]],
      local_last_name: ['', [Validators.required]],
      local_phone : ['', [Validators.required]],
      local_email: ['']
    });
  }

  ngAfterViewInit() {
        setTimeout(() => {
          const offcanvasElement = this.offcanvas?.nativeElement;
          if (offcanvasElement) {
            this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
              backdrop: 'static', 
              keyboard: false,
            });        
          }
        });
  }

  goBackToList(event : any){    
    this.router.navigate([this.breadcrumbList.breadcrumb_url]);
  }

  showHideDetails(){
    this.local_person_details = !this.local_person_details;
  }

  toggleLocakPersonDetails(){
    this.showHideDetails();
    if(this.ownerLocalContactDetails?.first_name && this.local_person_details) {
      this.localPersonForm.patchValue(this.ownerLocalContactDetails);
    }
    if (this.offcanvasInstance) {
        this.offcanvasInstance.show();
    }
  }

  cancel(){
    this.showHideDetails();
    this.localPersonForm.reset();
    if (this.offcanvasInstance) {
        this.offcanvasInstance.hide();
    }
  }

  onSubmit(){
    if(!this.localPersonForm.valid) return;
    this.updateOwnerBankdetailSubscription  = this.httpService.editUser(this.localPersonForm.value , this.userId).subscribe({
      next : (response) => {
        this.ownerLocalContactDetails = this.localPersonForm.value;
        this.cancel();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }
  
  getUserDetails(data : any){
    this.ownerLocalContactDetails = data["local_info"];
  }

  ngOnDestroy(){
    this.updateOwnerBankdetailSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
  }

  get checkUserLocalAdd() {
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_LOCAL_ADD);
  }

  get checkUserLocalEdit() {
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_LOCAL_UPDATE);
  }

}
